import { ReactElement, memo } from 'react';
import { SvgIconProps } from '@mui/material';

import RoutesIcon from '~components/Icons/Vehicle';

import { useSubscription } from '~hooks/useSubscription';
import { isPlanEFlex } from '~utils/plans';
import Subscription from '~components/Subscription';

const RoutesIconWrapper = (props: SvgIconProps): ReactElement => {
  const subscription = useSubscription();

  if (isPlanEFlex(subscription)) return <RoutesIcon {...props} />;

  return (
    <Subscription.AvailableRoutesState.Badge {...props}>
      <RoutesIcon />
    </Subscription.AvailableRoutesState.Badge>
  );
};

export default memo(RoutesIconWrapper);
